<script setup lang="ts">
import { StepperItem, StepperTrigger, type StepperItemProps } from "reka-ui";

interface Props extends Omit<StepperItemProps, "as" | "asChild"> {
	title?: string;
	icon?: string;
}

const props = defineProps<Props>();
</script>

<template>
	<StepperItem v-slot="slotProps" asChild v-bind="props">
		<StepperTrigger
			as="li"
			:class="{
				'step focus-visible:outline-hidden cursor-pointer': true,
				'step-neutral': slotProps.state === 'active',
				'step-primary': slotProps.state === 'completed',
			}"
		>
			<slot />
		</StepperTrigger>
	</StepperItem>
</template>
